import { render } from "./FileUploaderModel.vue?vue&type=template&id=78cc52c5"
import script from "./FileUploaderModel.vue?vue&type=script&lang=js"
export * from "./FileUploaderModel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__